// libraries.
import { useFormContext } from 'react-hook-form';

// styles.
import { WrapperInputField } from '@shared/InputField/styles';
import { ConfidenceLevel } from '@domains/documents-review/hooks/useFieldConfidence';
import { withRequiredMark } from '@shared/utils/fieldLabel';

interface DropdownFieldProps {
  label: string;
  name: string;
  options: { value: number | string; label: string }[];
  required?: boolean;
  confidenceLevel?: ConfidenceLevel;
  confidenceBorderColor?: string;
  confidenceBoxShadow?: string;
  onFieldEdit?: (fieldName: string) => void;
}

export const DropdownField = ({
  label,
  name,
  options,
  required = false,
  confidenceLevel,
  confidenceBorderColor,
  confidenceBoxShadow,
  onFieldEdit,
}: DropdownFieldProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const validationRules = {
    required: required ? 'Campo requerido' : false,
    setValueAs: (value: string | number) =>
      value !== '' && !isNaN(Number(value)) ? Number(value) : value,
  };

  const confidenceStyle =
    confidenceLevel && confidenceBorderColor && confidenceBoxShadow
      ? {
          border: `1px solid ${confidenceBorderColor}`,
          boxShadow: confidenceBoxShadow,
        }
      : {};

  const isDisabled = confidenceLevel === 'HIGH';

  // Get register props and extend onChange
  const { onChange: registerOnChange, ...registerProps } = register(
    name,
    validationRules
  );

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // Call the onFieldEdit callback when user edits
    if (onFieldEdit) {
      onFieldEdit(name);
    }
    // Call original react-hook-form onChange
    return registerOnChange(e);
  };

  return (
    <WrapperInputField>
      <label className="form-label" htmlFor={name}>
        {withRequiredMark(label, required)}
      </label>
      <select
        id={name}
        className="form-select"
        style={confidenceStyle}
        disabled={isDisabled}
        onChange={handleChange}
        {...registerProps}
      >
        <option value="">Seleccione una opción</option>
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className="d-flex justify-content-center">
        {errors[name] && (
          <small className="text-danger my-1 fw-bold">
            {errors[name]?.message as string}
          </small>
        )}
      </div>
    </WrapperInputField>
  );
};
